function cov_1cb0swtp3u() {
  var path = "/app/src/components/trust-banner/trust-banner.tsx";
  var hash = "ae61badd75b1eb8f5a2a47a13a20377084901a26";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/trust-banner/trust-banner.tsx",
    statementMap: {
      "0": {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 38,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "TrustBanner",
        decl: {
          start: {
            line: 17,
            column: 16
          },
          end: {
            line: 17,
            column: 27
          }
        },
        loc: {
          start: {
            line: 23,
            column: 10
          },
          end: {
            line: 39,
            column: 1
          }
        },
        line: 23
      }
    },
    branchMap: {},
    s: {
      "0": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ae61badd75b1eb8f5a2a47a13a20377084901a26"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1cb0swtp3u = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1cb0swtp3u();
import cn from 'classnames';
import React from 'react';
import { Typography } from 'src/components/v2/typography';
import { Icon } from '../icon';
import styles from './styles.css';
export function TrustBanner(_ref) {
  var className = _ref.className,
    title = _ref.title,
    description = _ref.description,
    icon = _ref.icon,
    iconClassName = _ref.iconClassName;
  cov_1cb0swtp3u().f[0]++;
  cov_1cb0swtp3u().s[0]++;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.container, className)
  }, /*#__PURE__*/React.createElement("span", {
    className: cn(styles.iconContainer, iconClassName)
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    bold: true,
    className: styles.title
  }, title), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption1",
    className: styles.subtitle
  }, description)));
}